﻿namespace WebPortal.Dialog.Modal {
    export class AccountInformation {
        constructor() { this.init(); }

        private init(): void {
            $("#navigation_lbt_account_information").off().on("click", () => {
                let requestParam: string = $("#hdf_se_request_param").val();
                if (!!requestParam) {
                    console.log("doLoadAccountinformation");
                    WebPortalHubObj.server.doLoadAccountInformation(requestParam);
                } else {
                    console.error("Error, no Request String found!");
                }
                return false;
            });

            $("#bt_account_information_change_password").off().on("click", () => {
                $("#pn_modal_account_information").modal("hide");
                ChangePasswordModal.show();
                return false;
            });

            WebPortalHubObj.client.ShowAccountinformation = (_AccountinformationData: any) => {
                $("#pn_progress_account_information").addClass("hidden");
                $("#pn_account_information_Cause").addClass("hidden");
                $("#bt_account_information_settings_save").removeAttr("disabled");

                // account
                const account = _AccountinformationData.Account;

                this.safeHtml("#pn_account_information_account_name", `${account.Firstname} ${account.Familyname}`);
                this.safeHtml("#pn_account_information_account_useremail", account.UserEMail);
                this.safeHtml("#pn_account_information_account_username", account.Username);
                this.safeHtml("#pn_account_information_account_divsion", account.Unit);
                this.safeHtml("#pn_account_information_account_phone", account.Phone ? `+${account.Phone}` : "");
                this.safeHtml("#pn_account_information_account_mobile", account.Mobile ? `+${account.Mobile}` : "");
                this.safeHtml("#pn_account_information_account_mail", account.Mail);

                this.safeHtml("#pn_account_information_account_hasprivatedrive", !!account.HasPrivateDrive ? "true" : "false");
                this.safeHtml("#pn_account_information_account_hasswisscomdrive", !!account.HasSwisscomDrive ? "true" : "false");

                this.safeHtml("#pn_account_information_account_validfrom", account.ValidFrom);
                this.safeHtml("#pn_account_information_account_validto", account.ValidTo);
                
                // maxSessionCount
                $("#pn_account_information_account_maxsessioncount").html(_AccountinformationData.Settings.MaxSessionCount);

                // assigned Access Groups
                $("#pn_account_information_assigned_access_groups").html("");
                let AssignedAccessGroups: any = _AccountinformationData.AssignedAccessGroups;
                for (let key in AssignedAccessGroups) {
                    if (AssignedAccessGroups.hasOwnProperty(key)) {
                        let phone: string = "";
                        if (AssignedAccessGroups[key].Phone) { phone = "Phone: +" + AssignedAccessGroups[key].Phone + "<br />"; }
                        let mobile: string = "";
                        if (AssignedAccessGroups[key].Mobile) { mobile = "Mobile: +" + AssignedAccessGroups[key].Mobile; }

                        $("#pn_account_information_assigned_access_groups").append(
                            this.getTitelDiv(AssignedAccessGroups[key].AccessGroup + " - " + AssignedAccessGroups[key].AccessGroupRole
                            ));

                        $("#pn_account_information_assigned_access_groups").append(
                            this.getBodyDiv(
                                AssignedAccessGroups[key].Firstname + " " + AssignedAccessGroups[key].Familyname + "<br />" +
                                AssignedAccessGroups[key].Mail + "<br />" +
                                phone + mobile
                            ));

                        $("#pn_account_information_assigned_access_groups").append(
                            this.getFooterDiv(AssignedAccessGroups[key].NotesInMySettings
                            ));
                    }
                }

                // pending Access Request
                $("#pn_account_information_pending_access_requests").html("");
                let PendingAccessRequests: any = _AccountinformationData.PendingAccessRequests;
                for (let key in PendingAccessRequests) {
                    if (PendingAccessRequests.hasOwnProperty(key)) {
                        $("#pn_account_information_pending_access_requests").append(
                            this.getTitelDiv(PendingAccessRequests[key].AccessGroup
                            ));
                        $("#pn_account_information_pending_access_requests").append(
                            this.getBodyDiv(
                                PendingAccessRequests[key].Name + " (" + PendingAccessRequests[key].Username + ")<br />" +
                                "<table><tr><td>ValidFrom:&nbsp;</td><td>" + PendingAccessRequests[key].ValidFrom + "</tr>" +
                                "<tr><td>ValidTo:&nbsp;</td><td>" + PendingAccessRequests[key].ValidTo + "</td></tr></table>"
                            ));
                        $("#pn_account_information_pending_access_requests").append(
                            this.getFooterDiv(""
                            ));
                    }
                }

                // settings
                $("#select_account_information_settings_Language")
                    .selectpicker("val", _AccountinformationData.Account.Language_ID);
                $("#pn_account_information_secondauthentication_info_IsDirexUser").addClass("hidden");
                $("#pn_account_information_secondauthentication_info_OtherUser").addClass("hidden");
                let Client2ndAuthLevel_ID: number = _AccountinformationData.Account.Client2ndAuthLevel_ID;
                if (Client2ndAuthLevel_ID === 2) {
                    $("#select_account_information_settings_SecondAuthentication").selectpicker("val", 2);
                }
                if (Client2ndAuthLevel_ID === 4) {
                      this.handleMobileIDAppSection(_AccountinformationData)
                }

                $("#select_account_information_settings_KeyboardLayout")
                    .selectpicker("val", _AccountinformationData.Settings.KeyboardLayout_ID);

                if (_AccountinformationData.Account.IsSupplierUser) {
                    $("#select_account_information_settings_InitializationTab").selectpicker("val", 1);
                    $("#select_account_information_settings_InitializationTab").attr('disabled', "true");
                } else {
                    $("#select_account_information_settings_InitializationTab").removeAttr("disable");
                    $("#select_account_information_settings_InitializationTab")
                        .selectpicker("val", _AccountinformationData.Settings.InitializationTab_ID);                    
                }
                $('.selectpicker').selectpicker('refresh');                                              
              
                $("#pn_modal_account_information").modal({ backdrop: "static", keyboard: true });
            };

            $("#bt_account_information_settings_save").off().on("click", () => {
                let settings: any = {
                    "KeyboardLayoutId": $("#select_account_information_settings_KeyboardLayout").val(),
                    "SecondAuthentication": $("#select_account_information_settings_SecondAuthentication").val(),
                    "InitializationTabId": $("#select_account_information_settings_InitializationTab").val(),
                    "LanguageId": $("#select_account_information_settings_Language").val()
                };

                let requestParam: string = $("#hdf_se_request_param").val();
                if (!!requestParam) {
                    console.info("doSaveMySettings");
                    $("#pn_progress_account_information").removeClass("hidden");
                    WebPortalHubObj.server.doSaveMySettings(requestParam, settings);
                } else {
                    console.error("Error, no Request String found!");
                }
                return false;
            });

            $("#bt_account_information_close").off().on("click", () => {
                $("#pn_modal_account_information").modal("hide");
                return false;
            });

            WebPortalHubObj.client.ShowMySettingsSavedError = (_Cause: string) => {
                $("#pn_progress_account_information").addClass("hidden");
                $("#pn_account_information_Cause").removeClass("hidden");
                $("#bt_account_information_settings_save").attr("disabled", "disabled");
                $("#pn_account_information_Cause").html(_Cause);
                $("#pn_account_information_Cause").addClass("alert-danger");
                $("#pn_modal_account_information").modal({ backdrop: "static", keyboard: true });
            };

            WebPortalHubObj.client.CloseMySettings = () => {
                $("#pn_modal_account_information").modal("hide");
            };
        }
        private handleMobileIDAppSection(_AccountinformationData) {
            $("#select_account_information_settings_SecondAuthentication").selectpicker("val", 1);

            $("#select_account_information_settings_SecondAuthentication option[value=1]").text("MobileID App");
            $("#pn_account_information_secondauthentication_info_IsDirexUser").addClass("hidden");
            $("#pn_account_information_secondauthentication_info_OtherUser").addClass("hidden");

            if (!!_AccountinformationData.Account.UserMIDMobile) {
                if (_AccountinformationData.Account.UserMIDMobile.indexOf(";app") === -1) {
                    $("#select_account_information_settings_SecondAuthentication option[value=1]").text("MobileID");

                    if (_AccountinformationData.Account.IsSwisscomUser) {
                        $("#pn_account_information_secondauthentication_info_IsDirexUser").removeClass("hidden");
                    } else {
                        $("#pn_account_information_secondauthentication_info_OtherUser").removeClass("hidden");
                    }
                }
            }
        }

        private getTitelDiv(_Title: string): JQuery {
            return $("<div>").attr({
                "class": "col-xs-12 col-md-6"
            }).append(
                $("<strong>").text(_Title)
            );
        }

        private getBodyDiv(_Body: any): JQuery {
            return $("<div>").attr({
                "class": "col-xs-12 col-md-6"
            }).html(_Body);
        }

        private getFooterDiv(_Footer: string): JQuery {
            return $("<div>").attr({
                "class": "col-xs-12 col-md-12"
            }).css({
                "paddingBottom": "5px"
            }).append(
                $("<small>").text(_Footer)
            );
        }
        
        private safeHtml(selector: string, value: string | null | undefined) {
            $(selector).html(value?.toString().trim() || "&nbsp;");
        }
    }
}